import React from 'react';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { userPermissions } from '../pages/UserDashboard';

const HomeNav = () => {
    const session = useSelector((state) => state.session);
    const isContentAdmin = session?.permissions?.includes(userPermissions.CONTENT_ADMIN);
    return (
        <nav className="sub-nav">
            <NavLink to="/register-user" className={({ isActive }) => classNames({ active: isActive })}>
                Add Shop User
            </NavLink>
            <NavLink to="/sop/monthly" className={({ isActive }) => classNames({ active: isActive })}>
                SOP Monthly
            </NavLink>
            <NavLink to="/sop/quarterly" className={({ isActive }) => classNames({ active: isActive })}>
                SOP Quarterly
            </NavLink>
            <NavLink to="/sop/rb-quarterly" className={({ isActive }) => classNames({ active: isActive })}>
                Recorded Books Quarterly
            </NavLink>
            {isContentAdmin && (
                <NavLink to="/categories" className={({ isActive }) => classNames({ active: isActive })}>
                    Categories
                </NavLink>
            )}
            <NavLink to="/customers/admins" className={({ isActive }) => classNames({ active: isActive })}>
                Admins
            </NavLink>
            <NavLink to="/customers/bop" className={({ isActive }) => classNames({ active: isActive })}>
                BOP Users
            </NavLink>
        </nav>
    );
};

export default HomeNav;
